import { render, staticRenderFns } from "./AdditionalInfoDialog.vue?vue&type=template&id=405631c7&scoped=true"
import script from "./AdditionalInfoDialog.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfoDialog.vue?vue&type=style&index=0&id=405631c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405631c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('405631c7')) {
      api.createRecord('405631c7', component.options)
    } else {
      api.reload('405631c7', component.options)
    }
    module.hot.accept("./AdditionalInfoDialog.vue?vue&type=template&id=405631c7&scoped=true", function () {
      api.rerender('405631c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/AdditionalInfoDialog.vue"
export default component.exports